<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">会員サイト利⽤登録解除仮受付</h1>
    </div>
    <div id="MailSetting" class="detail-cart my-5 border box-p-20">
      <h2 class="mb-5">
        会員登録解除申請を受付けました。
      </h2>
      <p class="mb-3 text-center">登録されたメールアドレス宛に、本解除のためのメールをお送りしました。</p>
      <p class="mb-3 text-center">メールを開き、メール本⽂にあるリンク先URLをクリックして解除実⾏ページを開いて「本解除」ボタンを押してください。</p>
    </div>
    <div class="my-5 text-center">
      <router-link to="/login" class="btn d-inline-block" >このページを閉じる</router-link >
    </div>
  </section>
</template>

<script>


export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>
<style>
.detail-cart div.c-radio div.radio_box div {
  min-width: 20%;
  margin-bottom: 10px;
}
.detail-cart div.c-radio div.radio_box label {
  font-weight: bold;
  cursor: pointer;
  font-size: 1.125em;
}
</style>
